import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart } from 'phosphor-react';

const Support = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50 noise-texture">
      {/* Header */}
      <header className="bg-white border-b border-stone-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-stone-100 rounded-lg transition-colors"
              data-testid="back-to-chat-btn"
              aria-label="Go back"
            >
              <ArrowLeft size={20} weight="duotone" />
            </button>
            <h1 className="font-serif font-semibold text-xl text-stone-800" data-testid="support-title">
              Help AraVela Grow
            </h1>
          </div>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-4 py-12">
        <div className="bg-white rounded-3xl p-8 shadow-sm">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-secondary/20 mb-4">
              <Heart size={32} weight="duotone" className="text-secondary" />
            </div>
            <h2 className="text-3xl font-serif font-semibold text-stone-800 mb-4">
              Help AraVela Grow
            </h2>
          </div>

          <div className="prose prose-stone max-w-none space-y-4 text-stone-700 leading-relaxed mb-8">
            <p>
              AraVela is being independently developed as a private, compassionate AI
              companion supporting emotional reflection, regulation, and personal agency.
            </p>
            <p>
              Your voluntary contributions help sustain its development, improve
              accessibility, and advance its broader mission of healing and human
              flourishing, including its connection to H.O.P.E. Homestead Sanctuary.
            </p>
            <p>
              Contributions through this page support AraVela and are not tax-deductible
              charitable donations.
            </p>
          </div>

          <a
            href="https://ko-fi.com/aravela"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-primary text-white rounded-full px-8 py-4 font-medium hover:shadow-soft transition-all duration-300 active:scale-95 flex items-center justify-center gap-2"
            data-testid="support-sanctuary-btn"
          >
            <Heart size={20} weight="duotone" />
            Support AraVela
          </a>

          <p className="text-center text-xs text-stone-400 mt-6">
            No prompts will appear during emotional sessions.
          </p>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/chat"
            className="text-stone-500 hover:text-primary transition-colors text-sm"
          >
            Return to Chat
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Support;
